export default __webpack_public_path__ + "static/media/icon_loading_email_512px.7f120a2b.gif";